export default "__VITE_ASSET__CIk05zWW__"